import { current } from "@reduxjs/toolkit";
import { useAppSelector, useAppDispatch } from "../../redux/hook";
import { getFromPath } from "../../service/dataLogic";
import { ReportObject } from "../../models/ReportModel";
import { checkForEditInSection, updateData } from "../../redux/dataSlice";

interface EditingToolbarProps {
    pageSelected: number;
    setPageSelected: (page: number) => void;
}

const EditingToolbar = ({pageSelected, setPageSelected}: EditingToolbarProps) => {
    const dispatch = useAppDispatch(); 
    let currentReport = useAppSelector((state) => state.data.currentReport);   
    
    const handleMultipageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!currentReport) return;
        const value = e.target.checked ? true : false;
        const path = "content.metadata.multipage";
        dispatch(updateData({'newValue':value,'path':path}))
        dispatch(checkForEditInSection(path))
    };

    if (!currentReport) {
        return null; // or some fallback UI
    }

    const metadata = getFromPath(currentReport, "content.metadata") as ReportObject;
    const multipageEnabled = !metadata ? false : metadata["multipage"] as boolean;

    return (
        <div className="flex flex-col items-end w-[75%]">
            <div className="bg-white border border-gray-200 rounded-lg shadow-sm px-4 py-2 flex self-end gap-3 mt-2">
                <label className="flex items-center gap-2 text-sm font-medium text-gray-700 cursor-pointer">
                <input
                    type="checkbox"
                    checked={multipageEnabled}
                    onChange={handleMultipageChange}
                    className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                />
                Multipage
                </label>
                {multipageEnabled && (
                <div className="flex items-center gap-2 border-l pl-3 ml-3">
                    <span className="text-sm text-gray-600">Page:</span>
                    <button 
                        onClick={() => setPageSelected(1)}
                        className={`px-2 py-1 text-sm border border-gray-300 rounded hover:bg-gray-50 ${pageSelected === 1 ? 'bg-blue-100 border-blue-500' : ''}`}
                    >
                        1
                    </button>
                    <button 
                        onClick={() => setPageSelected(2)}
                        className={`px-2 py-1 text-sm border border-gray-300 rounded hover:bg-gray-50 ${pageSelected === 2 ? 'bg-blue-100 border-blue-500' : ''}`}
                    >
                        2
                    </button>
                </div>
                )}
            </div>
        </div>
    );
};

export default EditingToolbar;
